import katex from 'katex';

// Quill's built-in Formula blot (and this app's SemanticFormula override in
// question-bank-detail.component.ts) read the KaTeX API off `window.katex`
// rather than an ES import - `Formula.create()` throws if `window.katex` is
// missing. Attach the bundled katex module to the global once so Quill's own
// formula rendering keeps working now that katex ships with the app instead
// of being loaded from a CDN `<script>` tag at runtime.
(window as unknown as { katex: typeof katex }).katex = katex;

export { katex };
